/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from "react";

const DeleteCheckLogDiscrepancies = ({ data = [] }) => {
  return (
    <div className="discrepancies-container pb-3">
      <div className="discrepancies-title-container">
        <span className="discrepancies-title">Discrepancies</span>
      </div>

      {data.map((item, index) => (
        <div className="discrepancies-item-container" key={`${item}-${index}`}>
          <span className="discrepancies-item">{item}</span>
        </div>
      ))}
    </div>
  );
};

export default DeleteCheckLogDiscrepancies;
